<template>
  <b-row>
    <b-col cols="12">
      <router-link :to="{ name: 'EXABAgreementsList' }" class="mb-1 btn btn-sm btn-default float-right">
        {{$t('buttons.backToList')}}
      </router-link>
    </b-col>
    <b-col cols="12" class="mt-2">
      <b-card>
        <loader v-if="isLoading"></loader>
        <div v-else class="card-body">
          <Form
            :handle-submit="handleSubmit"
            :initial-values="retrieved"
            :violations="violations">
          </Form>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import Form from './Form'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Loader from '@/components/Dashboard/Layout/Loader'

export default {
  name: 'Update',
  components: {
    Form,
    Loader
  },

  watch: {
    'updated' (val) {
      if (val) {
        this.$router.go(-1)
      }
    }
  },

  computed: {
    ...mapGetters({
      updated: 'agreements/update/updated',
      violations: 'agreements/update/violations',
      retrieved: 'agreements/update/retrieved',
      isLoading: 'agreements/update/isLoading'
    })
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(this.$route.params.id)
  },

  methods: {
    handleSubmit () {
      this.update(this.retrieved)
    },
    ...mapActions({
      update: 'agreements/update/update',
      retrieve: 'agreements/update/retrieve'
    }),
    ...mapMutations({
      reset: 'agreements/update/reset'
    })
  }
}
</script>
